module.exports = __webpack_public_path__ + "static/media/did-you-know-house-fire.6806cad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/callouts/did-you-know-house-fire.png
// module id = 1179
// module chunks = 0